import "./thank-you.css";

export default function ThankYou() {
  return (
    <div className="thankyou-wrapper">
      <div className="thankyou-card">
        <Illustration />

        <h1>Congratulations 🎉</h1>
        <p>You’re in.</p>
      </div>
    </div>
  );
}

function Illustration() {
  return (
    <svg
      className="thankyou-illustration"
      width="140"
      height="140"
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="100" cy="100" r="100" fill="#F3F1EC" />
      <rect x="50" y="70" width="100" height="70" rx="14" fill="#1F1F1F" />
      <rect x="60" y="80" width="80" height="50" rx="10" fill="#FFFFFF" />
      <circle cx="80" cy="105" r="5" fill="#C56A5A" />
      <circle cx="100" cy="105" r="5" fill="#C56A5A" />
      <circle cx="120" cy="105" r="5" fill="#C56A5A" />
    </svg>
  );
}
